









































































import { defineComponent, watch, ref, computed } from "@vue/composition-api";
import ProjectCard from "@c/molecules/project/ProjectCard.vue";
import EventCard from "@c/molecules/event/EventCard.vue";
import NoteCard from "@c/molecules/note/NoteCard.vue";
import PlaceCard from "@c/molecules/place/PlaceCard.vue";

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default defineComponent({
  name: "NetSlide",

  components: {
    ProjectCard,
    PlaceCard,
    EventCard,
    NoteCard,
    Swiper,
    SwiperSlide,
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    type: {
      type: String
    },
    title: {
      type: String
    },
    empty: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    withPlace: {
      type: Boolean,
      default: false
    },
    withLocation: {
      type: Boolean,
      default: false
    },
    all: String
  },

  setup(props, {root, refs}) {

    var swiperOption:any = computed(() => {
      return {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            600: {
              slidesPerGroup: 2,
              freeMode:false
            }
          }
      }
    })

    interface Swiper{
      $swiper: {
        isBeginning:boolean, 
        isEnd:boolean,
        slidePrev: ()=>{},
        slideNext: ()=>{}
      }
    }

    var show_previous = ref(false)
    var show_next = ref(false)

    const checkArrows = ()=>{
      setTimeout(()=>{
        show_previous.value = !(refs.mySwiperRef as Vue & Swiper).$swiper.isBeginning
        show_next.value = !(refs.mySwiperRef as Vue & Swiper).$swiper.isEnd
      },100)
    }


    watch(() => props.items, (newValue:any) => {
      checkArrows()
    }, {deep:false});



    const previous = () => {
      (refs.mySwiperRef as Vue & Swiper).$swiper.slidePrev()
      checkArrows()
    }

    const next = () => {
      (refs.mySwiperRef as Vue & Swiper).$swiper.slideNext()
      checkArrows()
    }

    return {
      swiperOption,
      previous,
      next,
      show_previous,
      show_next
    };
  }
});
